import axios from 'components/Axios';
import { Experience } from '../APIEndPoint';

const AddExperience = (payload) => {
  const promise = axios.post(`${Experience}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UpdateExperience = (payload, id) => {
  const promise = axios.put(`${Experience}/${id}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetExperienceById = () => {
  const getUsername = window.location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();
  const promise = axios.get(`${Experience}/byUserName/${currentUsername}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteExperience = (id) => {
  const promise = axios.delete(`${Experience}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { AddExperience, UpdateExperience, GetExperienceById, DeleteExperience };
